import { TemperaturesData } from "./TemperaturesData";
export default TemperaturesData;
